<nav style="display: flex; justify-content: space-between;height: 62px;" class="navbar navbar-expand-sm navbar-dark">

  <a class="navbar-brand" [routerLink]="['/']">
    <img src="assets/img/header_logo.png" class="logo-img" alt="Leaflet" />
    <span class="lable-role" *ngIf="((isLoginUser | async) ?? false)">{{userName}}</span>
    <span class="lable-role" *ngIf="((isLoginUser | async) ?? false)">{{franchiseName}}</span>
  </a>

  <!-- Navbar text-->
  <span class="navbar-text">
    Local Digital & Printed Menus - Budget Allocation Portal
  </span>

  <!-- Menu -->
  <ng-container *ngIf="(((isLoginUser | async) ?? false) && tempUser == false) else emptyDiv">
    <ul class="navbar-nav">
      <li class="nav-item" *ngIf="userRole === 'Franchise Partner'">
        <a class="nav-link" mat-icon-button [matMenuTriggerFor]="notiContent">
          <div class="noti-container">
            <img src="assets/svg/bell.svg" class="bell-icon" alt="bell-icon" />
            <div class="noti-count" *ngIf="unreadNotificationCount > 0">{{unreadNotificationCount}}</div>
          </div>
        </a>
        <mat-menu #notiContent="matMenu">
          <ul class="list-group list-group-flush notification-list">
            <ng-container *ngIf="(notiData.length > 0);else blankBellIcon;">
              <li class="list-group-item" *ngFor="let n of notiData;" [ngClass]="{'read': n.is_read, 'unread': !n.is_read}" (click)="markAsRead(n)">
                {{n.description}}</li>
            </ng-container>
            <ng-template #blankBellIcon>
              <li class="list-group-item">No Data</li>
            </ng-template>
          </ul>
        </mat-menu>
      </li>

      <li class="nav-item">

        <a class="nav-link" mat-button [matMenuTriggerFor]="menu" (click)="toggleMenu()">
          Menu <mat-icon svgIcon="menu-open" class="my-icon" [ngClass]="{'menu-open': isMenuOpen, 'menu-closed': !isMenuOpen}"></mat-icon>
        </a>

        <mat-menu #menu="matMenu" class="my-menu" (opened)="onMenuOpened()" (closed)="onMenuClosed()">

          <ng-container *ngIf="userRole === 'Super Admin'">
            <a class="mat-menu-item" [routerLinkActive]="['is-active']" routerLink="/dashboard">Dashboard</a>
            <a class="mat-menu-item" [routerLinkActive]="['is-active']" routerLink="/create-campaign">Create Campaign</a>
            <a class="mat-menu-item" [routerLinkActive]="['is-active']" routerLink="/create-franchise">Create Franchise</a>
            <a class="mat-menu-item" [routerLinkActive]="['is-active']" routerLink="/create-user">Create User</a>
            <a class="mat-menu-item" [routerLinkActive]="['is-active']" routerLink="/create-billing-group">Create Billing Group</a>
            <a class="mat-menu-item" [routerLinkActive]="['is-active']" routerLink="/create-store-v2">Create Store</a>
            <a class="mat-menu-item" [routerLinkActive]="['is-active']" routerLink="/fund-allocation-v2">Fund Allocation</a>
            <a class="mat-menu-item" [routerLinkActive]="['is-active']" routerLink="/franchise-summary">Franchise Summary</a>
            <a class="mat-menu-item" [routerLinkActive]="['is-active']" routerLink="/audit-trails">Audit Trails</a>
            <a class="mat-menu-item" [routerLinkActive]="['is-active']" routerLink="/reports">Reports</a>
            <a class="mat-menu-item" [routerLinkActive]="['is-active']" routerLink="/management">Management</a>
          </ng-container>

          <ng-container *ngIf="userRole === 'Franchise Partner'">
            <a class="mat-menu-item" [routerLinkActive]="['is-active']" routerLink="/franchise-summary">Franchise Summary</a>
            <a class="mat-menu-item" [routerLinkActive]="['is-active']" routerLink="/campaign-summary">Campaign Summary</a>
          </ng-container>

          <ng-container *ngIf="userRole === 'Head Office Role'">
            <a class="mat-menu-item" [routerLinkActive]="['is-active']" routerLink="/dashboard">Dashboard</a>
            <a class="mat-menu-item" [routerLinkActive]="['is-active']" routerLink="/reports">Reports</a>
          </ng-container>

          <a class="mat-menu-item" [routerLinkActive]="['is-active']" routerLink="/information">Information</a>
          <a class="mat-menu-item" [routerLinkActive]="['is-active']" routerLink="/faq">FAQs</a>
          <a class="mat-menu-item" (click)="logout()">Logout</a>
        </mat-menu>
      </li>
    </ul>
  </ng-container>
  <ng-template #emptyDiv>
    <div>&nbsp;&nbsp;</div>
  </ng-template>
</nav>